import { COLUMNS_NAME } from 'Components/Constants/ColumnsNames'
import { currency } from 'Components/MUI_components/currencyFormatterTag'
import Reports from 'Components/Print/a4-report-print'
import React from 'react'

function ClosingBalnaceSummery(props) {
    const {closingBalance} = props

    const cashTotal = closingBalance?.map((row) =>parseFloat(row.cashAmount) )
    .reduce((sum, i) => sum + i, 0);

    const chequeTotal = closingBalance?.map((row) => parseFloat(row.chequeAmount) )
    .reduce((sum, i) => sum + i, 0);

    return (
        <div>
            <div className="justify-content-center"
                // ref={componentRef}
                >
                <Reports
                    title={
                        "Closing Balance"
                    }
                >
                    <table
                        className="print-table mt "
                        aria-label="customized table"
                         >
                        <thead style={{ borderBottom: "1px solid #24242450" }}>
                            <tr>
                                <th align="left">{COLUMNS_NAME.CODE}</th>
                                <th align="left">{COLUMNS_NAME.LEDGER_TYPE}</th>
                                <th align="right">{COLUMNS_NAME.CASH_AMOUNT}</th>
                                <th align="right">{COLUMNS_NAME.CHEQUE_AMOUNT}</th>
                            </tr>
                        </thead>
                        {closingBalance.length > 0 && (
                             closingBalance.map((row, index) => (
                                <tbody >
                                    {row.cashAmount == "0.00" && row.chequeAmount == "0.00" ? ("") : (
                                        <tr>
                                             <td align="left">{row.code}</td>
                                             <td align="left">
                                                 {row.accLedgerTypeCode == 4601000001 ? "CASH BOOK" : "" ||
                                                 row.accLedgerTypeCode == 4601000003 ? "CREDIT CARD" : "" ||
                                                 row.accLedgerTypeCode == 4601000002 ? "BANK " : "" ||
                                                //  row.accLedgerTypeCode == 4601000004 ? "CAPITAL_ACCOUNT_PLR" : "" ||
                                                //  row.accLedgerTypeCode == 4601000005 ? "RICELAND_PVT_LTD" : "" || 
                                                //  row.accLedgerTypeCode == 4601000006 ? "CA_MR_RAFEEK" : ""
                                                 row.accLedgerTypeCode == 4601000004 ? "AMANA BANK" : "" ||
                                                 row.accLedgerTypeCode == 4601000005 ? "HNB" : "" || 
                                                 row.accLedgerTypeCode == 4601000006 ? "SAMPATH BANK" : ""
                                                 
                                                 }
                                             </td>
                                             {row.cashAmount <0 ? (   
                                             <td align="right"> { `(${currency(row.cashAmount)})`}</td>
                                                
                                             ): (
                                                    <td align="right">{currency(row.cashAmount)}</td>
                                             )}

                                             {row.chequeAmount <0 ? 
                                             (
                                                <td align="right">{`(${currency(row.chequeAmount)})`}  </td>

                                             ):
                                             (
                                                <td align="right">{currency(row.chequeAmount)}</td>

                                             )}

                                        </tr>
                                    ) }
                                   
                                </tbody>
    
                            ))
                        )}
                       
                    </table>
                    {closingBalance.length === 0 && (
                         <div style={{ textAlign: 'center' }}>Closing Balance Not Available</div>
                    )} 
                   {closingBalance.length > 0 && 
                      <div style={{ margin: 15 }}>
                        {chequeTotal<0 ? (
                        <div><strong> {`Cheque Total : (${currency(chequeTotal)})`} </strong> </div>
                        ) : (
                        <div><strong> {`Cheque Total : ${currency(chequeTotal)}`} </strong> </div>
  
                        )}
                        {cashTotal <0 ? 
                        (
                            <div><strong>{`Cash Total : (${currency(cashTotal)})`} </strong></div>
                        ) 
                        : 
                        (
                          <div><strong>{` Cash Total :  ${currency(cashTotal)}`} </strong></div>
                        ) }
                  </div>
                   } 
                  

                </Reports>

            </div>
        </div>
    )
}

export default ClosingBalnaceSummery